import{useDiContainerInjection as o}from"@edikk-edikk/di-container";import{DI_CONTAINER_TYPE as n}from"../objects/index.js";const r=()=>o(n.languageControl);export{r as useLanguageControl};
